export const blogFeatures = {
  features: [
    "Personalized Recommendations",
    "Watch by Spending Tokens",
    "Movie Discovery by Mood ",
    "Cross Platform",
    "No Subscription Required",
    "Community Picks"
  ],
  platforms: [
    {
      name: "Cineva",
      details: [
        "AI-powered based on mood, genre, and token system ",
        "Unique gamified experience",
        "Mood-based discovery engine",
        "Compares availability across all platforms",
        "Free to use with optional premium model",
        "Interact via Comments "
      ]
    },
    {
      name: "Netflix",
      details: [
        "Yes",
        "Not available",
        "Available",
        "Not Available",
        "Not Available",
        "Not Available",
      ]
    },
    {
      name: "Prime Video",
      details: [
        "Yes",
        "Not available",
        "Available",
        "Not Available",
        "Not Available",
        "Not Available",
      ]
    },
    {
      name: "Jiohotstar",
      details: [
        "Yes",
        "Not available",
        "Not Available",
        "Not Available",
        "Not Available",
        "Interact via comments",
      ]
    }
  ]
};
